export default __webpack_public_path__ + "static/media/case-study-8-bulldog-armoured-vehicle.bef73308.mp4";